import type { ReactNode } from "react";
import { useIsAuthenticated } from "@refinedev/core";

/**
 * De poort voor de applicatie: ingelogd toont de applicatie, niet ingelogd de inlogpagina.
 *
 * <p>Vervangt Refines {@code <Authenticated>} om één reden (Maarten, 2026-10-12: "wil geen disco"). Die toont
 * zijn laadtoestand bij élke controle, ook als die op de achtergrond wordt herhaald. Dan verdwijnt de hele
 * applicatie een tel en wordt ze opnieuw opgebouwd: het scherm knippert en wat iemand had ingetypt is weg. Hier
 * staat de laadtoestand er alleen zolang er nog geen antwoord is; wordt de controle herhaald, dan blijft staan wat
 * er stond tot het nieuwe antwoord binnen is. Uitloggen werkt als voorheen: het antwoord wordt "niet ingelogd"
 * en dan komt de inlogpagina.
 */
export function Inlogpoort({ fallback, loading, children }: { fallback: ReactNode; loading: ReactNode; children: ReactNode }) {
  const { data, isLoading } = useIsAuthenticated();
  if (!data && isLoading) {
    return <>{loading}</>;
  }
  return <>{data?.authenticated ? children : fallback}</>;
}
